import { Flow_0_0_2 } from '@flexus/core';

export const BET_61: Flow_0_0_2 = {
	id: '61',
	name: 'TL_complete_assesment',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for team leader assessment'
		}
	},
	startNode: '',
	nodes: {}
};
